import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './useAuth'

/** Route guard: renders child routes only when signed in, else bounces to /login. */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return <div className="grid min-h-svh place-items-center text-muted-foreground">Loading…</div>
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}
